module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/aoj_a-2-9e794307623894e0e0a00447ad0fc159.jpg";